// import React from 'react'

// const AddSalesPerson = () => {
//   return (
//     <div>AddSalesPerson</div>
//   )
// }

// export default AddSalesPerson

// import React from 'react'

// const AddEngineer = () => {
//   return (
//     <div>AddEngineer</div>
//   )
// }

// export default AddEngineer

import React, { useEffect, useState } from "react";
// import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
// import backicon from './../../../../../../Assets/icons/backIcon.svg';
import backicon from "../../../../../Assets/icons/backIcon.svg"
// import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
// import ROUTES_NAVIGATION from "../../../../../../routes/routes";
// import axiosInstance from "../../../../../services/api/API";
// import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import axiosInstance from "../../../../services/api/API";
import Loader from "../../../../customComponents/CustomLoader";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";

const AddSalesPerson = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([])
  const [roledd, setRoledd] = useState([])

  const [dealerOptions, setDealerOptions] = useState([])

  const userType = localStorage.getItem("UserType")
  console.log(userType, "USERTYPE")
  const businessPartnerId = localStorage.getItem("business_partner_id")

  useEffect(() => {
    fetchDealers()
  }, [])

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post("/dealer/ddldealer", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response?.data?.data?.data

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));


      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    userTypedropdown()
  }, [])

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      })

      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label: user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    roleDropdown()
  }, [])

  const roleDropdown = async () => {
    try {

      const payload = {

        business_partner_id: userType === "superadmin" ? formData?.business_partner_id : businessPartnerId,
      }

      const response = await axiosInstance.post("/role/ddlrole", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      })

      const data = response.data.data.data
      const roleOptions = data.map(role => ({
        value: role.ID,
        label: role.NAME,
      }))
      setRoledd(roleOptions)
    } catch (error) {
      console.log(error)
    }
  }


  const handleFormSubmit = async (formData) => {
    console.log("engineerFormData", formData);

    const errors = {};
    let isValid = true;

    DealerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          
          const payload = {
            sales_person_name: formData.sales_person_name,
            contact_no: formData.contact_no,
            sales_person_address: formData.sales_person_address,
            email_id: formData.email_id,
            sales_person_code: formData.sales_person_code,
            pan: formData.pan,
            country_id: formData.country_id,
            state_id: formData.state_id,
            city_id: formData.city_id,
            sales_pin_code: formData.pincode,
            status: formData.status === true ? 1 : 0,
          };
  
          // API call to create a dealer
          const response = await axiosInstance.post('/salesperson/create', payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          });


          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Sales Person added successfully!",
              icon: "success",
              confirmButtonText: "OK",
            }).then(() => {
              navigate("/admin/manage-sales-person/sales-person"); 
            });
          }

        } catch (error) {
          console.error('Error adding sales person:', error);
          const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "The record was not added.",
          icon: "info",
          confirmButtonText: "OK",
        });
        setLoading(false);
      }
    });
  };

  const DealerInputs = [
    {
      name: "sales_person_code",
      label: "Sales Person Code",
      type: "text",
      // required: true,
      // disabled:true,
      gridClass: "col-lg-4",
      placeholder: "Enter Sales Person Code",

    },
    {
      name: "sales_person_name",
      label: "Sales Person Name",
      placeholder: "Enter Sales Person",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,pattern: /^[A-Za-z\s]*$/, message: "Only Alphabets Are Allowed*"},
    },

    {
      name: "contact_no",
      label: "Contact No.",
      placeholder: "Enter Contact No.",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true, pattern: /^[6-9]/,
        minLength: 10,
        maxLength: 10,
        message1: "Contact No. should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit Contact No.",
      }
    },
    {
      name: "sales_person_address",
      label: "Sales Person Address",
      placeholder: "Enter Sales Person Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "email_id",
      label: "Email ID",
      placeholder: "Enter Email Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: "Please enter a valid Email Address" },
    },

    {
      name: "pan",
      label: "PAN No.",
      type: "text",
      placeholder: "Enter Pan No.",
      validation: {
        // required: true, 
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        message: "Please enter a valid 10-character PAN number",
        maxLength: 10,
      },
      // required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "pincode",
      label: "Pin Code",
      placeholder: "Enter Pin Code",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, maxLength: 6 },
    },
    {
      name: "city",
      label: "City",
      placeholder: "City",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "state",
      label: "State",
      placeholder: "State",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "country",
      label: "Country",
      placeholder: "Country",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    // {
    //   name: "role_id",
    //   label: "Role",
    //   type: "dropdown",
    //   options: roledd,
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      required: true,

      validation: { required: true },
    },
    // {
    //   name: "actions",
    //   label: "Actions",
    //   type: "multiselectdropdown",
    //   required: true,
    //   options: [
    //     { label: "Edit", value: "Edit" },
    //     { label: "Delete", value: "Delete" },
    //   ],
    //   gridClass: "col-lg-4",
    // },
  ];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Add New Sales Person</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Sales Person Details
            </span>
            <DynamicForm
              formConfig={DealerInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>
          <div className="btncontainer mt-3">
            <button
              onClick={() => {
                handleFormSubmit(formData);
              }}
              className="submit-btn"
            >
              Submit
            </button>
          </div></>
      )}
    </>
  );
};

export default AddSalesPerson;
